import { FuseRolesAndPermissionsModule } from './security/roles-and-permissions/roles-and-permissions.module';
import { NgModule } from '@angular/core';

import { LoginModule } from './authentication/login/login.module';
import { Login2Module } from './authentication/login-2/login-2.module';
import { RegisterModule } from './authentication/register/register.module';
import { Register2Module } from './authentication/register-2/register-2.module';
import { ForgotPasswordModule } from './authentication/forgot-password/forgot-password.module';
import { ForgotPassword2Module } from './authentication/forgot-password-2/forgot-password-2.module';
import { ResetPasswordModule } from './authentication/reset-password/reset-password.module';
import { ResetPassword2Module } from './authentication/reset-password-2/reset-password-2.module';
import { LockModule } from './authentication/lock/lock.module';
import { MailConfirmModule } from './authentication/mail-confirm/mail-confirm.module';
import { Error401Module } from './errors/401/error-401.module';
import { Error403Module } from './errors/403/error-403.module';
import { Error404Module } from './errors/404/error-404.module';
import { Error500Module } from './errors/500/error-500.module';
import { MaintenanceModule } from './maintenance/maintenence.module';
import { SearchModule } from './search/search.module';
import { FuseHomeModule } from './home/home.module';
import { FuseUsersModule } from './management/users/users.module';
import { FuseChatModule } from './chat/chat.module';
import { FuseStudentsModule } from './management/students/students.module';
import { FuseSchoolYearModule } from './management/schoolyear/schoolyear.module';
import { SubjectModule } from './management/subjects/subject.module';
import { CurriculumModule } from './management/curricula/curriculum.module';
import { DivisionsScheduleModule } from './management/divisions-schedule/divisions-schedule.module';
import { NgxDnDModule } from '@swimlane/ngx-dnd';
import { SchoolScheduleModule } from './events/school-schedule/school-schedule.module';
import { SchoolScheduleSchoolYearModule } from './management/schoolyear/school-schedule-school-year/school-schedule-school-year.module';
import { SubjectDivisionTeacherModule } from './management/subject-division-teacher/subject-division-teacher.module';
import { SchoolDataModule } from './management/school-data/school-data.module';
import { FuseEmployeeModule } from './management/employees/employees.module';
import { SchoolYearConceptModule } from './management/professional-concept/school-year-concept.module';
import { ConfigurationsModule } from './management/configurations/configurations.module';
import { NoticiasModule } from './management/noticias/noticias.module';
import { ExamCallsModule } from './management/exam-calls/exam-calls.module';
import { ExamBoardsModule } from './management/exam-boards/exam-boards.module';
import { ActosModule } from './management/actos/actos.module';



@NgModule({
    imports: [
        // Auth
        LoginModule,
        Login2Module,
        RegisterModule,
        Register2Module,
        ForgotPasswordModule,
        ForgotPassword2Module,
        ResetPasswordModule,
        ResetPassword2Module,
        LockModule,
        MailConfirmModule,

        // Errors
        Error401Module,
        Error403Module,
        Error404Module,
        Error500Module,

        // Maintenance
        MaintenanceModule,

        // Search
        SearchModule,

        // Home,
        FuseHomeModule,

        //

        // Management
        FuseUsersModule,

        // Security
        FuseRolesAndPermissionsModule,


        FuseChatModule,

        FuseStudentsModule,
        FuseSchoolYearModule,
        SubjectModule,
        CurriculumModule,
        DivisionsScheduleModule,
        SchoolScheduleModule,
        SchoolScheduleSchoolYearModule,
        SubjectDivisionTeacherModule,
        SchoolDataModule,
        FuseEmployeeModule,
        SchoolYearConceptModule,
        ConfigurationsModule,
        NoticiasModule,
        ExamCallsModule,
        ExamBoardsModule,
        ActosModule
    ]

})
export class PagesModule {
}



// WEBPACK FOOTER //
// ./src/app/main/content/pages/pages.module.ts